import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCFeral extends NPC {
    constructor() {
        super(definitions.NPC_ID.FERAL);

        this.collisionRadius = 10;
        this.collisionOffsetX = -4;
        this.collisionOffsetY = -28;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_feral_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.6, new PIXI.Point(-4, -12));
        this.animateIdle(0.45);
    }
}